const variables = {
  paginationRatio: 10,
  litigationsPaginationRatio: 4,
  horizontalSpace: '30px',
  horizontalPadding: '7vh',
  verticalSpace: '2vh'
};

export { variables };
